import axios from "@/libs/api.request";
export const getList = (params) => {
  return axios.request({
    url: "/finance/reimburse/flow",
    method: "get",
    params,
  });
};

export const getUser = (params) => {
  return axios.request({
    url: "/finance/reimburse/user",
    method: "get",
    params,
  });
};